import { ItsmeQrAuthenticationContent } from '../../components/itsme-qr-authentication-content/itsme-qr-authentication-content.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useItsmeQrAuthentication from './itsme-qr-authentication.controller';

const ID = 'itsme-qr-authentication';

const ItsmeQrAuthentication = () => {
    const viewProps = useItsmeQrAuthentication();

    return (
        <WizardScreenContainer id={ID}>
            <ItsmeQrAuthenticationContent {...viewProps} />
        </WizardScreenContainer>
    );
};

export default ItsmeQrAuthentication;
